import { render, staticRenderFns } from "./CadFormaPagamento.vue?vue&type=template&id=5fa6012e&"
import script from "./CadFormaPagamento.vue?vue&type=script&lang=js&"
export * from "./CadFormaPagamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports